module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " padding-left-30 padding-right-30 padding-bottom-30"
  }, [_c('div', {
    staticClass: "vctb-list"
  }, [_c('div', {
    staticClass: "vctb-item",
    class: {
      'vctb-item-active': _vm.vctbIndex == 0
    },
    on: {
      "click": function($event) {
        _vm.vctbIndex = 0
      }
    }
  }, [_vm._v("\n\t\t\t经营异常 (" + _vm._s(_vm.jygroup.totalnum) + ")\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "vctb-item",
    class: {
      'vctb-item-active': _vm.vctbIndex == 1
    },
    on: {
      "click": function($event) {
        _vm.vctbIndex = 1
      }
    }
  }, [_vm._v("\n\t\t\t行政处罚 (" + _vm._s(_vm.xzgroup.totalnum) + ")\n\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "padding-left-10 padding-right-10 "
  }, [(_vm.vctbIndex == 0) ? [_vm._m(0), _vm._v(" "), _vm._l((_vm.jy_list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "box5"
    }, [_c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(_vm._s(item.addDate || "--") + " ")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(_vm._s(item.addReason || "--") + " ")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(_vm._s(item.addOrgan || "--") + " ")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(_vm._s(item.removeDate || "--"))]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(_vm._s(item.removeReason || "--"))]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(_vm._s(item.removeOrgan || "--"))])])
  }), _vm._v(" "), (!_vm.jy_list.length) ? _c('div', {
    staticClass: "padding-bottom-40"
  }, [_c('nomore')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "padding": "10px 0"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.jygroup.pagesize,
      "page-sizes": _vm.pageSizes,
      "hide-on-single-page": false,
      "layout": "prev, pager, next,sizes",
      "current-page": _vm.jygroup.currentPage,
      "total": _vm.jygroup.totalnum
    },
    on: {
      "size-change": function($event) {
        return _vm.handleSizeChange($event, 'jygroup')
      },
      "current-change": function($event) {
        return _vm.handleCurrentChange($event, 'jygroup')
      }
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.vctbIndex == 1) ? [(_vm.detail) ? _c('div', [_vm._m(1), _vm._v(" "), _vm._l((_vm.xz_list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "box5"
    }, [_c('div', {
      staticClass: "box5_text2"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(item.publicDate ? _vm.dayjs(Number(item.publicDate) * 1000).format('YYYY-MM-DD') : "--") + "\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(_vm._s(item.punishmentDate || "--") + " ")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(_vm._s(item.punishmentNo || "--") + " ")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2 "
    }, [_vm._v(_vm._s(item.punishmentInfo || "--"))]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2  "
    }, [_vm._v(_vm._s(item.punishmentType || "--"))]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2  "
    }, [_vm._v(_vm._s(item.punishmentOrgan || "--"))])])
  }), _vm._v(" "), (!_vm.xz_list.length) ? _c('div', [_c('nomore')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "padding": "10px 0"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.xzgroup.pagesize,
      "page-sizes": _vm.pageSizes,
      "hide-on-single-page": false,
      "layout": "prev, pager, next,sizes",
      "current-page": _vm.xzgroup.currentPage,
      "total": _vm.xzgroup.totalnum
    },
    on: {
      "size-change": function($event) {
        return _vm.handleSizeChange($event, 'xzgroup')
      },
      "current-change": function($event) {
        return _vm.handleCurrentChange($event, 'xzgroup')
      }
    }
  })], 1)], 2) : _vm._e()] : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box5 box2_cc"
  }, [_c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("列入日期")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("列入经营异常名录原因 ")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("列入决定机关")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("移出日期")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("移出经营异常名单原因")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("移出决定机关")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box5 box2_cc"
  }, [_c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("公示日期")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("处罚决定日期 ")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("决定书文号")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("行政处罚内容")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("违法行为类型")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("决定机关")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a0b6e5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/company/components/abnormal-page.vue
// module id = 892
// module chunks = 1